import { DismissingCardContext } from "../DismissingCard/DismissingCardContext";
import { Close } from "../Icons";
import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { CircleDismissButton } from "./styles";

export const DismissButton = () => {
  const theme = useContext(ThemeContext);
  const { dismiss } = useContext(DismissingCardContext);

  return /*#__PURE__*/(
    React.createElement(CircleDismissButton, { onClick: dismiss, icon: /*#__PURE__*/React.createElement(Close, { color: theme.colors['Level 4'] }) }));

};